import { Box, Link, Center, Heading, Flex } from "@chakra-ui/react";
import BaseLayout from "../../components/base_layout";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, {
  Autoplay,
  Pagination,
  Navigation,
  EffectFade,
} from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/effect-fade";
import styles from "../../styles/Home.module.css";
import { GetReviewData } from "../api/base";
import React, { useState, useEffect, useRef } from "react";
import { useRouter } from "next/router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

SwiperCore.use([Autoplay, Pagination, Navigation, EffectFade]);

export default function CompanyAbout() {
  const [reviews, setReviews] = useState([]);
  const router = useRouter();
  const handleClick = async () => {
    router.push("/estimate/home");
  };

  const elementsRefA = useRef([]);
  const elementsRefB = useRef([]);

  useEffect(() => {
    const observerA = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add("animate");
            }, index * 200); // fast for search_tp
            observerA.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    const observerB = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add("animate");
            }, index * 400); // slower for quote_ex
            observerB.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    elementsRefA.current.forEach((el) => el && observerA.observe(el));
    elementsRefB.current.forEach((el) => el && observerB.observe(el));
  }, []);

  async function _getReview() {
    const data = await GetReviewData();
    setReviews(data);
  }

  useEffect(() => {
    _getReview();
  }, []);

  return (
    <BaseLayout>
      <Box>
        <Box>
          <Box className="intro_wrap">
            <section className="intro_highlight">
              <div className="highlight_tp">
                <Box className="highlight_lft">
                  <div className="highlight_ex">
                    <div>
                      <p>우리 회사에 딱 맞는 서비스</p>
                    </div>
                    <h4>
                      전자부품 검색은 <br /> 이제 판다파츠에서
                    </h4>
                    <span>
                      가격비교, 주문, 통관 및 배송까지 <br />
                      자동화된 온라인 서비스를 경험해 보세요.
                    </span>
                  </div>
                </Box>
                <Box className="highlight_rt">
                  <img src="/images/intro_example/intro3.png" />
                </Box>
              </div>
            </section>
            <section className="intro_search">
              <Box className="intro_search_wrap">
                <div className="search_tp">
                  <div
                    className="fadeUpBlur"
                    ref={(el) => (elementsRefA.current[0] = el)}
                  >
                    <p>전자부품 가격 비교</p>
                  </div>
                  <h4
                    className="fadeUpBlur"
                    ref={(el) => (elementsRefA.current[1] = el)}
                  >
                    단 한번의 검색으로
                  </h4>
                  <span
                    className="fadeUpBlur"
                    ref={(el) => (elementsRefA.current[2] = el)}
                  >
                    글로벌 유통사의 실시간 재고와 가격 정보를
                    <br /> 비교하고 안전하게 구매 할 수 있습니다.
                  </span>
                </div>

                <Box className="idx_logo_lft idx_logo_tp">
                  <ul>
                    <li>
                      <img src="./images/brand/search/digikey_logo.png" />
                    </li>
                    <li className="logo_arrow">
                      <img src="./images/brand/search/arrow_logo.png" />
                    </li>

                    <li>
                      <img src="./images/logo/tti.png" />
                    </li>
                    <li className="logo_mouser">
                      <img src="./images/brand/search/mouser_logo.svg.png" />
                    </li>
                    <li className="logo_element14">
                      <img src="./images/brand/main/element14_logo.png" />
                    </li>
                    <li className="logo_onechip">
                      <img src="./images/brand/search/onechip_logo.png" />
                    </li>
                    <li className="logo_verical">
                      <img src="./images/brand/search/verical_logo.png" />
                    </li>
                    <li>
                      <img src="./images/logo/future.png" />
                    </li>
                  </ul>
                  <ul>
                    <li className="logo_harting">
                      <img src="./images/brand/main/harting_logo.svg.png" />
                    </li>
                    <li className="logo_apem">
                      <img src="./images/logo/apem.png" />
                    </li>
                    <li className="logo_texasindustry">
                      <img src="./images/logo/texasinstruments.png" />
                    </li>
                    <li className="logo_microchip">
                      <img src="./images/logo/microchip.svg.png" />
                    </li>
                    <li className="logo_inferion">
                      <img src="./images/logo/inferion.png" />
                    </li>
                    <li className="logo_minicircuits">
                      <img src="./images/logo/minicircuits.png" />
                    </li>
                    <li className="logo_dfrobot">
                      <img src="./images/brand/search/dfrobot_logo.png" />
                    </li>

                    <li>
                      <img src="./images/logo/rochester.png" />
                    </li>
                  </ul>
                </Box>
              </Box>
            </section>
            <section className="intro_quote">
              <Box className="quote_wrap">
                <div className="quote_ex">
                  <h4
                    className="fadeInOnly quote_ex_title"
                    ref={(el) => (elementsRefB.current[3] = el)}
                  >
                    내가 찾는 전자부품,
                    <br /> 자동 견적부터 글로벌 소싱까지 쉽고 빠르게
                  </h4>
                  <h4
                    className="fadeInOnly quote_ex_title_mobile"
                    ref={(el) => (elementsRefB.current[3] = el)}
                  >
                    내가 찾는 전자부품,
                    <br /> 자동 견적부터 글로벌 소싱까지 <br /> 쉽고 빠르게
                  </h4>
                  <span
                    className="fadeInOnly"
                    ref={(el) => (elementsRefB.current[4] = el)}
                  >
                    BOM 업로드 한 번으로, 1분 이내 자동 견적 완성!
                    <br />
                    글로벌 소싱 네트워크를 통해 최적의 가격과 재고를
                    찾아드립니다.
                  </span>

                  <Link
                    className="fadeInOnly slow"
                    ref={(el) => (elementsRefB.current[5] = el)}
                    onClick={(e) => {
                      e.preventDefault(); // Next.js 라우팅 막기
                      window.location.href = "/estimate/home"; // 강제 새로고침 이동
                    }}
                  >
                    <span>판다봇 견적</span>

                    <FontAwesomeIcon icon={faArrowRight} />
                  </Link>
                </div>
                <div className="quote_key_features">
                  <ul className="features_wrap">
                    <li>
                      <p>
                        <p>
                          <img
                            src="/images/new_product.png"
                            alt=""
                            width="60px"
                            height="none"
                          ></img>
                        </p>
                      </p>
                      <h5>신제품 실시간 런칭</h5>
                      <span>
                        매일 1~2만개 신규 전자부품이<br></br>등록됩니다.
                      </span>
                    </li>
                    <li>
                      <p>
                        <p>
                          <img
                            src="/images/onestop_platform.png"
                            alt=""
                            width="60px"
                            height="none"
                          ></img>
                        </p>
                      </p>
                      <h5>OneStop 플랫폼</h5>
                      <span>
                        전자부품 실시간 메타서치로
                        <br></br>한번에 비교하고 구매하세요.{" "}
                      </span>
                    </li>
                    <li>
                      <p>
                        <p>
                          <img
                            src="/images/honest_market.png"
                            alt=""
                            width="60px"
                            height="none"
                          ></img>{" "}
                        </p>
                      </p>
                      <h5>정품판매</h5>
                      <span>
                        전세계 공식 대리점, <br />
                        유통사를 통해 정품 판매
                        <br />
                      </span>
                    </li>
                    <li>
                      <p>
                        <p>
                          <img
                            src="/images/security_warranty.png"
                            alt=""
                            width="60px"
                            height="none"
                          ></img>{" "}
                        </p>
                      </p>
                      <h5>정품인증</h5>
                      <span>
                        글로벌 공식 대리점, 유통사를 통해
                        <br />
                        정품 판매(100% COC
                        <br />
                        (Certificate of Compliance) 제공)
                      </span>
                    </li>
                  </ul>
                </div>
              </Box>
            </section>
            <section className="intro_before_after">
              <div>
                <h3
                  className="fadeInOnly intro_before_after_title"
                  ref={(el) => (elementsRefB.current[6] = el)}
                >
                  복잡한 글로벌 소싱, 판다파츠로 간편하게
                </h3>

                <h3
                  className="fadeInOnly intro_before_after_title_mobile"
                  ref={(el) => (elementsRefB.current[6] = el)}
                >
                  복잡한 글로벌 소싱, <br />
                  판다파츠로 간편하게
                </h3>
                <p
                  className="fadeInOnly"
                  ref={(el) => (elementsRefB.current[7] = el)}
                >
                  글로벌 공식 유통사 및 제조사의 실시간 데이터를 <br />
                  비교하고 구매하세요.
                </p>

                <div className="before_after_table">
                  <table>
                    <thead>
                      <tr>
                        <th className="title"></th>
                        <th className="before">이용 전</th>
                        <th className="after">이용 후</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="title">전자부품 구매방법</td>
                        <td className="title">
                          직접 거래처와 컨텍하여 주문시간 소요 많음<br></br>
                          구매시 거래처별 각각 주문 진행
                        </td>
                        <td className="after_text">
                          웹/앱에서 언제 어디서나 글로벌 공식 유통사, 대리점을
                          <br></br>한번에 가격 비교하고 구매
                        </td>
                      </tr>
                      <tr>
                        <td className="text">전자부품 배송비</td>
                        <td className="text">
                          유통사(제조사)별 개별 배송비 각각 발생
                        </td>
                        <td className="after_text">
                          여러 글로벌 공식 유통사를 통해서 구매해도
                          <br></br>
                          <span className="light">
                            국내 배송비 한 번만 발생
                          </span>
                          <br></br>(5만원 이상{" "}
                          <span className="light">구매시 국내 배송 무료</span>)
                        </td>
                      </tr>
                      <tr>
                        <td className="text">전자부품 매입수량</td>
                        <td className="text">소량 구매가 어려움, 높은 단가</td>
                        <td className="after_text">
                          단 1개도 <span className="light">구매</span> 가능,
                          전자부품 가격비교를 통해 최적가 구매
                        </td>
                      </tr>
                      <tr>
                        <td className="text">결제 관리</td>
                        <td className="text">
                          해외송금, 입금, 카드 등 개별 관리 및<br></br>추가
                          수수료 발생
                        </td>
                        <td className="after_text">
                          카드결제, 무통장입금, 후불결제, 신용거래, 네이버페이
                          등<br></br>국내{" "}
                          <span className="light">모든 결제 수단 가능</span>,
                          원화 결제
                        </td>
                      </tr>
                      <tr>
                        <td className="text">통관 관리</td>
                        <td className="text">
                          개별 업체마다 영수증, 계산서 수입관리
                        </td>
                        <td className="after_text">
                          무역 전문가 통관 대행 및
                          <span className="light">비용 절감</span>
                        </td>
                      </tr>
                      <tr>
                        <td className="text">세금계산서 관리 </td>
                        <td className="text">
                          개별 업체마다 영수증, 계산서 수입관리
                        </td>
                        <td className="after_text_last">
                          단 한장으로 <span className="light">간편 관리</span>{" "}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </section>
            <section className="intro_review">
              <div className="review_ex">
                <h4
                  className="fadeInOnly"
                  ref={(el) => (elementsRefB.current[8] = el)}
                >
                  판다파츠 이용 후기
                </h4>
                <span
                  className="fadeInOnly"
                  ref={(el) => (elementsRefB.current[9] = el)}
                >
                  무료 항공특송으로 빠르게 배송!<br></br>
                  <span
                    style={{
                      color: "#E53E3E",
                      display: "inline-block",
                      marginRight: "3.5px",
                    }}
                  >
                    고객의 마음으로 바잉부터 배송까지
                  </span>
                  전 과정을 책임집니다.
                </span>
              </div>
              <Box className="review_wrap">
                <Swiper
                  spaceBetween={30}
                  slidesPerView={4.5}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                >
                  {reviews.length > 0 &&
                    reviews.map((review) => (
                      <SwiperSlide className="review_swiper" w="280px">
                        <Link href="/board/review">
                          <div className="photo">
                            <img
                              src={
                                review.item.it_img1 ||
                                review.item.it_img2 ||
                                "/images/no_img.png"
                              }
                            />
                            <div>
                              <p>{review.item.it_name}</p>
                              <p>{review.item.it_brand}</p>
                            </div>
                          </div>
                          <div className="content">
                            <p className="review_tit">{review.is_subject}</p>
                            <div className={styles.author}>
                              <p className="review_author">{review.mb_id}</p>
                              <p className="review_star">
                                <img
                                  src="/images/review_star.png"
                                  alt="메인배너"
                                  width="100px"
                                  height="none"
                                ></img>
                              </p>
                            </div>
                          </div>
                        </Link>
                      </SwiperSlide>
                    ))}
                </Swiper>
              </Box>
            </section>
          </Box>
        </Box>
      </Box>
    </BaseLayout>
  );
}
